import { ReactComponent as EditIcon } from "assets/images/icons/btn_edit.svg";
import { ReactComponent as RemoveIcon } from "assets/images/icons/icn_btn_bin.svg";
import { ReactComponent as RemoveHoverIcon } from "assets/images/icons/icn_btn_bin_hover.svg";

import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Tooltip, Typography } from "@mui/material";

const ActionIcons = ({
  rowData,
  showEditGeneral,
  editIpAddressProfile,
  deleteIpAddressProfile,
}) => {
  const [isRemoveHovered, setIsRemoveHovered] = useState(false);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <EditIcon
        aria-label={`Edit ${rowData.ipGroupName}`}
        role="button"
        onClick={() => editIpAddressProfile(rowData)}
        style={{ cursor: "pointer", margin: "0 6px 0 2px", width: "18px", height: "18px" }}
      />
      {showEditGeneral && (
        <>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: "primary.greyThread",
              height: "20px",
              width: "1px",
              margin: "0 10px",
            }}
          />
          <Box
            aria-label={`Delete ${rowData.ipGroupName}`}
            role="button"
            onMouseEnter={() => setIsRemoveHovered(true)}
            onMouseLeave={() => setIsRemoveHovered(false)}
            onClick={() => deleteIpAddressProfile(rowData)}
            sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            {isRemoveHovered ? (
              <RemoveHoverIcon style={{ width: "20px", height: "20px", margin: "0 6px 0 2px" }} />
            ) : (
              <RemoveIcon style={{ width: "20px", height: "20px", margin: "0 6px 0 2px" }} />
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

const EllipsisTooltipCell = ({ text }) => {
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflow(element.scrollWidth > element.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip
      title={isOverflow ? <Typography sx={{ whiteSpace: "normal" }}>{text || "-"}</Typography> : ""}
      disableHoverListener={!isOverflow}
      arrow
    >
      <Box
        ref={textRef}
        sx={{
          flex: 1,
          minWidth: 0,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text || "-"}
      </Box>
    </Tooltip>
  );
};

export const getTableColumns = (
  theme,
  columnHelper,
  showEditGeneral,
  editIpAddressProfile,
  deleteIpAddressProfile
) => [
  columnHelper.accessor("ipGroupName", {
    header: "IP Group Name",
    meta: {},
    cell: info => (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <EllipsisTooltipCell text={info.getValue()} />
      </Box>
    ),
  }),
  columnHelper.accessor("ips", {
    header: "IPs",
    meta: {},
    cell: info => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {info.getValue()}
      </Box>
    ),
  }),
  columnHelper.display({
    id: "action",
    header: "Action",
    meta: { isAction: true },
    cell: info => {
      const rowData = info.row.original;

      return (
        <ActionIcons
          rowData={rowData}
          showEditGeneral={showEditGeneral}
          editIpAddressProfile={editIpAddressProfile}
          deleteIpAddressProfile={deleteIpAddressProfile}
        />
      );
    },
  }),
].filter(Boolean);

export const fromJSON = (data) => {
  return {
    id: data.id,
    ipGroupName: data.name,
    ips: data.ipList.length,
    ref: data,
  };
};

const toApiIpList = (ipAddresses) => {
  return ipAddresses.map((item) => ({
    ...item,
    subnet: Number(item.subnet),
  }));
};

export const toJSON = (data, id = null) => {
  if (id) {
    return {
      id,
      name: data.name,
      ipList: toApiIpList(data.ipAddresses),
    };
  }

  return {
    name: data.name,
    ipList: toApiIpList(data.ipAddresses),
  };
};
